<template>
  <b-modal
      title="業務"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div class="row">
        <div class="col-3 mb-4">
          <b-form-select
            v-model="search.status"
            :options="options.status" />
        </div>

        <div class="col-3 mb-4">
          <b-form-input
            autofocus
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="業務編號"
            v-model="search.number"
            @keyup.enter="getSales(1)" />
        </div>

        <div class="col-3 mb-4">
          <b-form-input
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="業務姓名"
            v-model="search.name"
            @keyup.enter="getSales(1)" />
        </div>

        <div class="col-3">
          <b-button variant="success" @click="getSales(1)">搜尋</b-button>
        </div>
      </div>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
        :pageData="page"
        v-on:result="getSales"
      >
        <template #cell(function)="row">
          <b-button
            v-if="row.item.isShowSelectBtn"
            variant="info"
            size="sm"
            @click="select(row.item)"
          >
            選取
          </b-button>
        </template>
      </tables-page>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import businessApi from "@/models/API/businessApi";

export default {
  name: 'BusinessSelectModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage,
  },
  data () {
    return {
      options: {
        status: [
          { value: 0, text: '正常' },
          { value: 1, text: '失效' },
          { value: 2, text: '停權' },
        ],
      },
      status: {
        isLoading: false
      },
      search: {
        status: 0,
        number: '',
        name: '',
      },
      table_fields: [
        {
          key: "number",
          label: "業務編號",
        },
        {
          key: "name",
          label: "業務姓名",
        },
        {
          key: "function",
          label: "功能"
        }
      ],
      page: {},
      table_data: [],
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.resetSearchCriteria();
          
          this.getSales();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.page = Object.assign({}, this.businessApi.page);
  },
  methods: {
    // 查詢業務
    getSales(pageIndex = null) {
      this.status.isLoading = true;

     const params = {
        ...this.search,
        'PageSize': this.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.page.pageIndex,
      };
      this.businessApi.getSales((response) => {
        const res = response.data;

        this.page.totalCount = res.total; // 總筆數
        this.table_data = res.data.map(item => {
          return {
            ...item,
            isShowSelectBtn: this.search.status === 0 ? true : false
          }
        });

        this.status.isLoading = false;
      }, params, false)
    },
    // 重置搜尋條件
    resetSearchCriteria() {
      this.search ={
        status: 0,
        number: '',
        name: '',
      };
    },
    // 選擇業務
    select(item) {
      this.$emit('select', item);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BusinessSelectModal.vue